import { useEffect } from 'react'
import thread from 'app/thread'
import debounce from 'lib/util/debounce'

/**
 * Create an ResizeObserver instance for a ref
 *
 * @param {RefObject} ref - Ref for the React element (result of useRef call)
 * @param {Function} callback - the callback function on resize
 * @param {boolean} isEnabled - whether is enabled
 */
export default function useResizeObserver (ref, callback, isEnabled = true) {
  useEffect(() => {
    const isWindow = ref.current === window
    let observer
    let debouncedCallback

    if (isEnabled && ref.current) {
      const observerCallback = entries => {
        callback(isWindow ? window : entries?.[0])
      }

      debouncedCallback = debounce(observerCallback, 0)

      observer = isWindow
        ? thread.onResize.on(debouncedCallback)
        : new ResizeObserver(debouncedCallback)

      if (ref.current !== window) {
        observer.observe(ref.current)
      }
    }

    return () => {
      observer?.disconnect?.()

      if (isWindow) {
        thread.onResize.off(debouncedCallback)
      }

      debouncedCallback?.cancel?.()
    }
  }, [ref, callback, isEnabled])
}
